import { render, staticRenderFns } from "./AddKelistrikan.vue?vue&type=template&id=c316459e&scoped=true&lang=pug&"
import script from "./AddKelistrikan.vue?vue&type=script&lang=js&"
export * from "./AddKelistrikan.vue?vue&type=script&lang=js&"
import style0 from "./AddKelistrikan.vue?vue&type=style&index=0&id=c316459e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c316459e",
  null
  
)

export default component.exports